import {Component, OnInit} from '@angular/core';
import {EducationMaterialApi} from "../../types/apiResponse.interface";
import {ActivatedRoute} from "@angular/router";
import {PreloaderService} from "../../services/preloader/preloader.service";
import {StudentService} from "../../services/mygreencountry/student.service";
import {MyGreenCountry} from "../../services/mygreencountry/my-greencountry";
import {TranslocoService} from "@jsverse/transloco";
import {Observable} from "rxjs";
import {Title} from "@angular/platform-browser";

@Component({
    selector: 'app-textbook',
    templateUrl: './textbook.page.html',
    styleUrls: ['./textbook.page.scss'],
})
export class TextbookPage implements OnInit {

    title$: Observable<string>;

    public educationalMaterial: EducationMaterialApi;
    public groupId: number | undefined;

    constructor(private route: ActivatedRoute,
                private preloaderService: PreloaderService,
                private studentService: StudentService,
                public myGcService: MyGreenCountry,
                private translocoService: TranslocoService,
                private titleService: Title,)
    {
        this.title$ = this.translocoService.selectTranslate('route.textbook');

        this.title$.subscribe(title => {
            this.titleService.setTitle(title);
        });

    }

    ngOnInit() {
        this.route.paramMap.subscribe(params => {
            let groupId = params.get('id') as string;

            if (groupId) {

                this.loadData(groupId);
            }

        });

    }

    refresh(event: any) {
        if (this.groupId) {
            this.loadData(this.groupId.toString(), event);
        }
    }


    async loadData(groupId: string, event: any = null) {
        await this.preloaderService.showLoading('Зачекайте, будь ласка');

        this.studentService.getEducationalMaterial(groupId)

            .subscribe({

                next: (response: EducationMaterialApi) => {

                    this.educationalMaterial = response;
                    this.groupId = response.id;
                },

                error: (error) => {

                    //@TODO: show error message
                    console.log('error', error)

                },

                complete: () => {

                    this.preloaderService.hideLoading();
                    if (event) {
                        event.target.complete();
                    }

                }

            })
    }

    openUrl(url: string, selfStudy: boolean = false, title:string) {
        if (url) {
            let lessonNumber = title.match(/\d+/)?.[0] ?? '';

            if (selfStudy && this.groupId) {
                this.myGcService.cleanCacheEBook(this.groupId, lessonNumber)
                    .subscribe({
                        next: (response) => {
                        },
                        error: (error) => {
                        },
                        complete: () => {
                        }
                    })
            }

            this.myGcService.openUrl(url)
        }
    }
}
